import React from 'react';

// Streamed from the existing public S3 bucket (same one that serves lesson animations/images) —
// the mp4 is deliberately NOT in the repo. Swapping the video here changes what every
// past-sent WhatsApp/email link plays, with no Meta template re-approval needed.
const VIDEO_URL =
  'https://prod-nova-learning.s3.eu-west-2.amazonaws.com/videos/Nova+Learning+-+Full+Walkthrough+(EDITED).mp4';

/**
 * Public page for the free-trial-complete WhatsApp/email video link (/watch/membership).
 * Plays the full walkthrough showing what's included with a Nova membership. Distinct from
 * /watch, which plays the pre-assessment diagnostic walkthrough for the welcome message.
 */
export default function WatchMembership() {
  return (
    <div style={{ maxWidth: 720, margin: '40px auto', padding: 24, textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
      <h2>What's included with a Nova membership</h2>
      <p>Watch this short video to see how we'll continue to support your child's learning journey.</p>
      <video
        src={VIDEO_URL}
        controls
        playsInline
        preload="metadata"
        style={{ width: '100%', borderRadius: 8, backgroundColor: '#000' }}
      >
        Your browser does not support video playback.
        <a href={VIDEO_URL}>Download the video instead.</a>
      </video>
    </div>
  );
}
